module.exports = __webpack_public_path__ + "assets/img/b96b-mk.svg";